module.exports = __webpack_public_path__ + "static/media/comprobanteHC.1efe98bd.svg";